export default {
    BASE_V1_API: 'https://site-api.fsyueji.cn/api/v1', // https://site-api.viewglass.cn/api/v1
    BASE_V1_TEST_API: 'https://site-api.fsyueji.cn/api/v1'
} 